export default __webpack_public_path__ + "images/YST.fbc83ea.png";